var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReassign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.65,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2828 10.2828C21.4391 10.1266 21.4391 9.87337 21.2828 9.71716L18.7373 7.17157C18.581 7.01536 18.3278 7.01536 18.1716 7.17157C18.0154 7.32778 18.0154 7.58105 18.1716 7.73726L20.4343 10L18.1716 12.2627C18.0154 12.419 18.0154 12.6722 18.1716 12.8284C18.3278 12.9846 18.581 12.9846 18.7373 12.8284L21.2828 10.2828ZM7 10.4H21V9.6H7V10.4Z",
    fill: "#696969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71716 18.2828C6.56095 18.1266 6.56095 17.8734 6.71716 17.7172L9.26274 15.1716C9.41895 15.0154 9.67222 15.0154 9.82843 15.1716C9.98464 15.3278 9.98464 15.581 9.82843 15.7373L7.56569 18L9.82843 20.2627C9.98464 20.419 9.98464 20.6722 9.82843 20.8284C9.67222 20.9846 9.41895 20.9846 9.26274 20.8284L6.71716 18.2828ZM21 18.4H7V17.6H21V18.4Z",
    fill: "#696969"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReassign);
export default __webpack_public_path__ + "static/media/reassign.d73ead40fb29f4641a16a78422a9ded1.svg";
export { ForwardRef as ReactComponent };